import { gql } from '@apollo/client';

export const GLOBAL_SEARCH = gql`
  query GlobalSearch($searchQuery: String!, $teamIds: [ID!], $category: String, $limit: Int, $searchContent: Boolean, $documentFormats: [String!]) {
    globalSearch(searchQuery: $searchQuery, teamIds: $teamIds, category: $category, limit: $limit, searchContent: $searchContent, documentFormats: $documentFormats) {
      results {
        resultType
        id
        title
        subtitle
        status
        workspaceName
        workspaceId
        relevanceScore
        updatedAt
        dealId
        documentId
        templateId
        isOrgTemplate
        snippet
        clauseHeading
        clauseType
        contactData {
          id
          name
          email
          phone
          company
          title
          address
          contactType
          customFields
        }
      }
      totalCount
      categoryCounts
    }
  }
`;
